import React, { Component } from 'react'
import './input.scss'

class Input extends Component {
	constructor(props) {
		super(props)
		this.state = {
			placeholder: props.placeholder ? props.placeholder : ' ',
			type: props.type ? props.type : 'text',
			label: props.label ? props.label : '',
			state: props.state ? props.state : '',
			showIcon: props.icon ? 'show-icon' : '',
			labelClasses: props.labelClasses ? props.labelClasses : '',
			classes: props.classes ? props.classes : ''
		}
	}

	render() {
		const classes = ['input', this.state.classes, this.props.state].join(' ')
		const labelClass = ['group vbui--text', this.state.labelClasses, this.props.showIcon ? 'show-icon' : ''].join(' ')
		return (
			<div className={labelClass}>
				{this.props.showIcon && <span className={this.props.icon}></span>}
				<input
					disabled={this.props.disabled}
					className={classes}
					name={this.props.name}
					placeholder={this.state.placeholder}
					type={this.props.type}
					value={this.props.value}
					onChange={this.props.onChange}
					required={this.props.required}
					readOnly={this.props.readonly}
				/>
				<label>{this.props.label}</label>
			</div>
		)
	}
}

export default Input
